import { render, staticRenderFns } from "./serRecordDetail.vue?vue&type=template&id=bb19ba66&scoped=true"
import script from "./serRecordDetail.vue?vue&type=script&lang=js"
export * from "./serRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./serRecordDetail.vue?vue&type=style&index=0&id=bb19ba66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb19ba66",
  null
  
)

export default component.exports